import React from 'react';
import { Link } from 'react-router-dom';
import 'styles/common.css';
import './CompanyOverview.css';

const CompanyOverview = () => {
  return (
    <div className="company-overview-page">
      <div className="company-container">
        <div className="company-header">
          <Link to="/" className="back-button">← Back to Home</Link>
          <h1 className="company-title">Company Overview</h1>
          <p className="company-subtitle">Pioneering AI and Quantum Mechanics Integration</p>
        </div>

        <div className="company-content">
          <section className="content-section">
            <h2>About Genion Quantum Technologies</h2>
            <p>
              Genion Quantum Technologies is a high-tech enterprise driven by proprietary artificial intelligence (AI) 
              and quantum mechanics (QM) innovation. The company is dedicated to deeply integrating advanced large 
              language models (LLMs) and Transformer architectures into two frontier fields — life sciences and 
              environmental sciences.
            </p>
            <p>
              Leveraging its self-developed AI technology platform, Genion combines quantum mechanics computation 
              with multi-source data analysis to provide cutting-edge intelligent solutions for drug discovery and 
              ecological environmental management.
            </p>
          </section>

          <div className="mission-highlight">
            <h3>Our Mission</h3>
            <p>
              To revolutionize drug discovery and environmental management through the seamless integration of 
              artificial intelligence and quantum mechanics, creating sustainable solutions for global challenges.
            </p>
          </div>

          <section className="content-section">
            <h2>Drug Discovery Innovation</h2>
            <div className="feature-grid">
              <div className="feature-card">
                <h3>AI-Powered R&D Platform</h3>
                <p>
                  Built an AI-powered R&D platform that integrates proprietary LLMs, Transformer architectures, 
                  and QM computations to enable precise drug structure discovery and optimization.
                </p>
              </div>
              <div className="feature-card">
                <h3>Efficient Development</h3>
                <p>
                  Through efficient synergy of in-house algorithms and independently developed pipelines, 
                  the platform significantly shortens R&D cycles, reduces costs, and improves hit rates.
                </p>
              </div>
              <div className="feature-card">
                <h3>Broad Applications</h3>
                <p>
                  Applied in various domains including small molecules, peptides, antibodies, and nanobodies, 
                  demonstrating strong potential in both scientific research and industrial applications.
                </p>
              </div>
            </div>
          </section>

          <section className="content-section">
            <h2>Environmental Management Solutions</h2>
            <div className="feature-grid">
              <div className="feature-card">
                <h3>Intelligent Monitoring System</h3>
                <p>
                  Developed an intelligent environmental monitoring and decision-support system powered by AI, 
                  with a focus on addressing cyanobacteria blooms in the Taihu Basin.
                </p>
                <p>
                  The system integrates multi-source data and applies advanced techniques such as Transformer-based 
                  time-series modeling and Bayesian change-point detection to achieve precise predictions of algal 
                  dynamics and quantitative evaluations of management strategies.
                </p>
              </div>
              <div className="feature-card">
                <h3>Multidisciplinary Expertise</h3>
                <p>
                  Developed by a multidisciplinary team with expertise in statistics, artificial intelligence, 
                  environmental modeling, and full-stack development, featuring high-accuracy forecasting, 
                  real-time alerts, and multi-scenario strategy simulations.
                </p>
              </div>
            </div>
          </section>

          <section className="content-section">
            <h2>Future Vision</h2>
            <p>
              Applications extend beyond the Taihu Basin to other lakes and watersheds across China, 
              supporting the construction of "digital twin lakes." Future expansions include fisheries 
              resource management, water resource scheduling, and climate adaptation planning — offering 
              significant industrial potential and social benefits.
            </p>
            <p>
              We are committed to pushing the boundaries of what's possible in computational science, 
              driving innovation that benefits both human health and planetary well-being.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CompanyOverview;